'use strict';

angular.module('webAgro1App').controller('OcorrenciasMaquinasCtrl', function($scope, $rootScope, $q, $route, $location, $routeParams, $window, Flash, $uibModal,
        OcorrenciasMaquinasService, LoadingService, MessagesService, MaquinasService, PessoasService, PeriodSelectService, ItensManutencaoService, CommonHTTPService) {

  $rootScope.bodyClass = 'list-filter-body';
  $scope.tiposOcorrenciasMaquinas = TIPOS_OCORRENCIAS_MAQUINAS;
  $scope.tiposControleMaquina = TIPOS_CONTROLE_MAQUINA;
  $scope.tiposStatusOcorrenciaMaquina = TIPOS_STATUS_OCORRENCIA_MAQUINA;
  $scope.filtroTiposStatusOcorrenciaMaquina = Object.keys(TIPOS_STATUS_OCORRENCIA_MAQUINA).map(function(key) {
    return TIPOS_STATUS_OCORRENCIA_MAQUINA[key];
  });
  var modal = null;

  $scope.inStatus = function(ocorrencia, status) {
    return ((ocorrencia || {}).status || {}).id === $scope.tiposStatusOcorrenciaMaquina[status].id;
  };

  $scope.isOpened = function(ocorrencia) {
    return $scope.inStatus(ocorrencia, 'aberto');
  };

  $scope.isOpenedStatus = function(index) {
    return $scope.isOpened($scope.ocorrencias[index]);
  };

  $scope.isClosedStatus = function(index) {
    var closed = $scope.inStatus($scope.ocorrencias[index], 'fechado');
    var checked = $scope.inStatus($scope.ocorrencias[index], 'checado');
    return closed && !checked;
  };

  $scope.openPeriodsFilter = function(event) {
    if (event) {
      event.preventDefault();
    }
    PeriodSelectService.openPeriodSelection($scope.filters.period, $scope.filters);
  };

  $scope.resetPeriodsFilter = function() {
    $scope.filters.dataInicial = null;
    $scope.filters.dataFinal = null;
    $scope.filters.period = {
      eventDates: [],
      periodo: ''
    };
  };

  var initializeVariables = function() {
    if ($rootScope.ocorrenciasMaquinasBackupFilters) {
      $scope.filters = $rootScope.ocorrenciasMaquinasBackupFilters;
    } else {
      $scope.filters = {
        status: $scope.tiposStatusOcorrenciaMaquina.aberto
      };
      $scope.resetPeriodsFilter();
    }
    $scope.ocorrencias = null;
    $scope.ocorrencia = null;
    $scope.pages = {};
  };

  var initialize = function() {
    LoadingService.showLoading();
    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.maquina.canRead) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        return;
      }

      if ($routeParams.id) {
        var error = function() {
          Flash.create(REGISTRO_NAO_EXISTE.type, REGISTRO_NAO_EXISTE.msg);
          $scope.goToIndex();
        };

        OcorrenciasMaquinasService.getOcorrenciaMaquina($routeParams.id).then(function(data) {
          $scope.ocorrencia = data;
          if (!$scope.ocorrencia || !$scope.ocorrencia.id) {
            setTimeout(function() {
              $window.history.back();
            },100);
            return;
          }
        }, error).finally(LoadingService.hideLoading);
      } else {
        initializeVariables();
        getSelectsFields().finally($scope.buscarClick);
      }
    }, $rootScope.errorRootInitialize);
  };

  function getSelectsFields() {
    var deferred = $q.defer();

    var promises = [
      MaquinasService.list(),
      PessoasService.listMaoDeObra(),
      ItensManutencaoService.list()
    ];

    $q.all(promises).then(function(data) {
      $scope.maquinas = data[0].data || [];
      $scope.operadores = data[1].data || [];
      $scope.itensManutencao = data[2].data || [];
      deferred.resolve();
    }, deferred.reject);

    return deferred.promise;
  }

  var dateIsBefore = function(data, dataComparacao) {
    return moment(data).startOf('day').isBefore(moment(dataComparacao).startOf('day'));
  };

  $scope.getOcorrenciasMaquinas = function() {
    LoadingService.showLoading();
    $scope.ocorrencias = null;
    $scope.resumo = null;

    $rootScope.ocorrenciasMaquinasBackupFilters = $scope.filters;

    var promises = [
      OcorrenciasMaquinasService.list($scope.filters),
      OcorrenciasMaquinasService.summary($scope.filters)
    ];

    $q.all(promises).then(function(data) {
      $scope.ocorrencias = (data[0].data || []).map(function(result) {
        result.tipo = OcorrenciasMaquinasService.getTipo(result.st_tipo);
        result.status = $scope.tiposStatusOcorrenciaMaquina[result.status];
        result.foraDoPrazo = result.status.id === TIPOS_STATUS_OCORRENCIA_MAQUINA.aberto.id &&
                            dateIsBefore(result.data_prazo);

        result.foraDoPrazoDeChecagem = result.status.id === TIPOS_STATUS_OCORRENCIA_MAQUINA.fechado.id &&
                             dateIsBefore(result.data_prazo_checagem);
        return result;
      });
      $scope.pages = data[0].pages || {};
      $scope.resumo = data[1].data || {};
    }, function() {
      MessagesService.alert('Não foi possível buscar as Ocorrências de Máquinas.');
    }).finally(LoadingService.hideLoading);
  };

  $scope.setPage = function(page) {
    var isEqual = $scope.filters.page && $scope.filters.page === page;
    if ((typeof(page) === 'undefined') || (!$scope.filters.page && page === 1) || isEqual) {
      return;
    }
    $scope.filters.page = page;
    $scope.getOcorrenciasMaquinas();
  };

  $scope.buscarClick = function() {
    $scope.filters.page = null;
    $scope.showResumo = true;
    $scope.getOcorrenciasMaquinas();
  };

  $scope.goToIndex = function() {
    $location.path('/ocorrencias_maquinas');
  };

  var setUrlOcorrenciaMaquina = function(ocorrencia, url) {
    if (ocorrencia) {
      $location.path('/ocorrencias_maquinas/' + ocorrencia.id + (url || ''));
    }
  };

  $scope.showOcorrencia = function(index) {
    setUrlOcorrenciaMaquina($scope.ocorrencias[index]);
  };

  $scope.show = function() {
    setUrlOcorrenciaMaquina($scope.ocorrencia);
  };

  $scope.edit = function() {
    setUrlOcorrenciaMaquina($scope.ocorrencia, '/edit');
  };

  $scope.delete = function() {
    MessagesService.confirm('Deseja excluir a Ocorrência desta máquina?').then(function() {
      LoadingService.showLoading();
      OcorrenciasMaquinasService.delete($scope.ocorrencia.id).then(function() {
        $scope.goToIndex();
        Flash.create(REGISTRO_EXCLUIDO_COM_SUCESSO.type, REGISTRO_EXCLUIDO_COM_SUCESSO.msg);
      }, function(error) {
        const message = CommonHTTPService.isBadRequest(error.status) ?  error.data : FALHA_AO_EXCLUIR_REGISTRO.msg;
        MessagesService.alert(message);
      }).finally(LoadingService.hideLoading);
    });
  };

  $scope.addClose = function(index) {
    $scope.ocorrencia = $scope.ocorrencias[index] || {};
    $scope.doClose();
  };

  $scope.doClose = function() {
    if ($scope.isOpened($scope.ocorrencia)) {
      if (!$rootScope.permissions.maquina.canManage || !$scope.ocorrencia.id) {
        return;
      }

      $scope.ocorrencia.fechado = {
        data: new Date(),
        hora: moment().milliseconds(0).toDate()
      };

      modal = $uibModal.open({
        templateUrl: 'views/ocorrencias_maquinas/modal/closed.html',
        scope: $scope
      });
    }
  };

  $scope.check = function(index) {
    MessagesService.confirm('Confirma que esta ocorrência foi fechada e verificada?').then(function() {
      $scope.loadingDelete = true;
      OcorrenciasMaquinasService.validateCheck($scope.ocorrencias[index]).then(function() {
        $route.reload();
        Flash.create(REGISTRO_SALVO_COM_SUCESSO.type, REGISTRO_SALVO_COM_SUCESSO.msg);
      }, function() {
        Flash.create(FALHA_AO_SALVAR_REGISTRO.type, FALHA_AO_SALVAR_REGISTRO.msg);
      }).finally(function() {
        LoadingService.hideLoading();
      });
    });
  };

  $scope.doSaveClose = function() {
    if (!$scope.ocorrencia.fechado.data || !$scope.ocorrencia.fechado.hora) {
      MessagesService.alert('Informe a Data/Hora');
      return;
    }

    if (!$scope.ocorrencia.fechado.dataPrazoChecagem ) {
      MessagesService.alert('Informe o prazo para checagem');
      return;
    }

    if (dateIsBefore($scope.ocorrencia.fechado.dataPrazoChecagem, $scope.ocorrencia.fechado.data)) {
      MessagesService.alert('O prazo para checagem não pode ser anterior ao fechamento, verifique.');
      return;
    }

    LoadingService.showLoading();
    OcorrenciasMaquinasService.doSaveClose($scope.ocorrencia).then(function() {
      if ($routeParams.id === $scope.ocorrencia.id) {
        $route.reload();
      } else {
        $scope.show();
      }
      Flash.create(REGISTRO_SALVO_COM_SUCESSO.type, REGISTRO_SALVO_COM_SUCESSO.msg);
    }, function() {
      Flash.create(FALHA_AO_SALVAR_REGISTRO.type, FALHA_AO_SALVAR_REGISTRO.msg);
    }).finally(function() {
      $scope.closeModalOcorrencia();
      LoadingService.hideLoading();
    });
  };

  $scope.addComment = function(index) {
    $scope.ocorrencia = $scope.ocorrencias[index] || {};
    $scope.createComment();
  };

  $scope.createComment = function() {
    if (!$rootScope.permissions.maquina.canManage || !$scope.ocorrencia.id) {
      return;
    }

    $scope.ocorrencia.comentario = null;

    modal = $uibModal.open({
      templateUrl: 'views/ocorrencias_maquinas/modal/addComment.html',
      scope: $scope
    });
  };

  $scope.saveComment = function() {
    if (!$scope.ocorrencia.comentario || !$scope.ocorrencia.comentario.length) {
      MessagesService.alert('Informe o comentário.');
      return;
    }

    LoadingService.showLoading();
    OcorrenciasMaquinasService.saveComment($scope.ocorrencia).then(function() {
      if ($routeParams.id === $scope.ocorrencia.id) {
        $route.reload();
      } else {
        $scope.show();
      }
      Flash.create(REGISTRO_SALVO_COM_SUCESSO.type, REGISTRO_SALVO_COM_SUCESSO.msg);
    }, function() {
      Flash.create(FALHA_AO_SALVAR_REGISTRO.type, FALHA_AO_SALVAR_REGISTRO.msg);
    }).finally(function() {
      $scope.closeModalOcorrencia();
      LoadingService.hideLoading();
    });
  };

  $scope.closeModalOcorrencia = function() {
    modal.dismiss('cancel');
  };

  $scope.deleteComment = function(id) {
    var indice = 0;
    var comentario = $scope.ocorrencia.comentarios.filter(function(comentario, index) {
      if (comentario.id === id) {
        indice = index;
        return comentario;
      }
    })[0];

    if (!($scope.ocorrencia || {}).id || !comentario) {
      return;
    }

    MessagesService.confirm('Deseja excluir o comentário da Ocorrência desta máquina?').then(function() {
      LoadingService.showLoading();
      OcorrenciasMaquinasService.deleteComment($scope.ocorrencia.id, comentario.id).then(function() {
        $scope.ocorrencia.comentarios.splice(indice, 1);
        Flash.create(REGISTRO_EXCLUIDO_COM_SUCESSO.type, REGISTRO_EXCLUIDO_COM_SUCESSO.msg);
      }, function() {
        MessagesService.alert(FALHA_AO_EXCLUIR_REGISTRO.msg);
      }).finally(LoadingService.hideLoading);
    });
  };

  $scope.$watchCollection('filters', function(newValue, oldValue) {
    if (newValue && oldValue && Object.keys(newValue).length && Object.keys(oldValue).length) {
      $scope.resumo = false;
    }
  });

  initialize();
});
